<template>
  <BaseDataList ref="dataList" :items="accounts" :service="fetchAccounts">
    <template #header>
      <AccountListHeader />
    </template>

    <template #default="{ item }">
      <AccountListItem
        :contact-id="contactId"
        :account="item"
        @account-updated="refreshList"
        @account-removed="refreshList"
      />
    </template>
  </BaseDataList>
</template>

<script>
import { contactAccountsClient } from '@/api/clients';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import AccountListHeader from './AccountListHeader.vue';
import AccountListItem from './AccountListItem.vue';

export default {
  components: {
    AccountListHeader,
    AccountListItem,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      accounts: [],
    };
  },
  methods: {
    refreshList() {
      this.$refs.dataList.resetList();
      this.$emit('change');
    },
    async fetchAccounts() {
      try {
        const response = await contactAccountsClient.list(this.contactId, {
          include: 'logo',
        });

        this.accounts = response.data.map(mapKeysToCamelCase);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
